export default "__VITE_ASSET__Bn$47K75__"